import { Component, Output, EventEmitter, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { LoginService } from '../../../components/login/login.service';
import { GeoServices } from '../../../services/geo.service';
import { UserProfileService } from '../../../components/user-profile/user-profile.service';
import { FormComponentI } from '../../../shared/interfaces/form-component-i.interface';
import { InternalStateEvent } from '../../../shared/models/internal-state-event';
import { StateMiscArgument } from 'nm-socle-application/app/shared/models/customer-config';
import { FormControl } from '@angular/forms';
import { ConfigService } from 'nm-socle-application/app/services/config.service';
import { Observable } from 'rxjs';
import {AbstractComponent} from 'nm-socle-application/app/shared/models/abstract-component';

@Component({
    selector: 'login-mail-form',
    templateUrl: './login-mail-form.component.html',
    styleUrls: ['./login-mail-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class LoginMailFormComponent extends AbstractComponent implements FormComponentI {
    public userProfil: any = {};
    public isChangingEmail:boolean = false;
    public currentEmail:string;

    public email: string;
    public emailInp = new FormControl();
    public emailValid:boolean = false;

    public emailCtrl: string;
    public emailCtrlInp = new FormControl();
    public emailCtrlValid:boolean = false;

    @Output() public closeEvent: EventEmitter<any> = new EventEmitter();
    @Output() public internalStateEvent: EventEmitter<InternalStateEvent> = new EventEmitter();
    @Input() public misc:StateMiscArgument[] = [];

    constructor(
        private _configService:ConfigService,
        private _loginService: LoginService,
        public userProfileService: UserProfileService,
        public geoServices: GeoServices,
        protected _cd:ChangeDetectorRef,
    ) {
        super(_cd);
    }

    public ngOnInit() {
        super.ngOnInit();

        this._loginService.loggedInUser.subscribe((user) => {
            if (user) {
                this.userProfil = user;

                this.currentEmail = this.userProfil.user_email;
            }
            this.markForCheck();
        });

        this._subs.push(this.emailInp.statusChanges.subscribe(evt => {
            this.emailValid = evt == 'VALID' && this.emailInp.valid;
            this._checkEmail();

            this.markForCheck();
        }));

        this._subs.push(this.emailCtrlInp.statusChanges.subscribe(evt => {
            this._checkEmail();

            this.markForCheck();
        }));
    }

    protected _checkEmail() {
        this.emailCtrlValid = this.emailCtrlInp.valid && this.email == this.emailCtrl;
    }

    public submitEmailChange() {
        this.isChangingEmail = true;
        this.userProfil.user_email = this.email;
        this.userProfil.user_email_check = true;

        return this.userProfileService.updateUserEmail(this.userProfil.user_id, this.email).catch(err => {
                this.isChangingEmail = false;
                return Observable.of(false)
            }).subscribe((updatedUser) => {
                this.isChangingEmail = false;

                this.closeEvent.emit('changeEmailOk');
                this.markForCheck();
            });
    }

    public logout() {
        this._loginService.logout();

        window.location.reload();
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/components/login/login-mail-form/login-mail-form.component.ts